import React, { useState, useEffect } from 'react';
import { useParams, Link,useLocation } from 'react-router-dom';
import DefaultLayout from '../../../Components/DefaultLayout';
import { TabContext, TabPanel, TabList } from '@mui/lab';
import { Box, Tab, Grid, FormControl, Button, InputLabel, MenuItem, OutlinedInput, Select,useMediaQuery } from '@mui/material';
// import Enrolled from '../../../Components/MyLeads/AffiliateMyLeads/Enrolled';
// import Upgraded from '../../../Components/MyLeads/AffiliateMyLeads/Upgraded';
import EligibleAffiliateList from './Components/EligibleAffiliateList';
import MediaServiceEnabledAffiliateList from './Components/MediaServiceEnabledAffiliateList';
import MediaServiceReqestedAffiliateList from './Components/MediaServiceReqestedAffiliateList';
import BlockAffiliateList from './Components/BlockAffiliateList';
import { DateRangePicker ,createStaticRanges} from 'react-date-range';
import { format, subDays } from 'date-fns';
import Freez from '../../../Components/Loader/Loader'
import Backdrop from '@mui/material/Backdrop';
import AuthUser from '../../../Components/Auth/AuthUser';
import { Typography } from '@mui/joy';
import swal from "sweetalert";
import { useSelector, useDispatch } from 'react-redux';
import { fetchData, postData } from '../../../redux/apiSlice';
import { calendarFilter,useDateSelectionRange,getInitialSelectionRange } from '../../../Components/CommonFormula';

function AdminMediaServices(props) {
    const dispatch = useDispatch();
     const {user} = AuthUser();
    // const { tab } = useParams();
    const location = useLocation();
    const tab = location.pathname.split("/").pop();
    const [value, setValue] = React.useState(tab);
    const isMobile = useMediaQuery('(max-width:600px)');
    useEffect(() => {
        console.log("value",value);
        setValue(tab);
    }, [tab])
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    
    const sideBar = calendarFilter();
    const staticRanges = [
        // ...defaultStaticRanges,
        ...createStaticRanges(sideBar)
    ];


    //loader function and variable start
    const [freez, setFreez] = React.useState(false);
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    //loader function and variable end
    const ContentLayout=
            <>
              
                    <Grid container item lg={12} md={12} sm={12} xs={12} mb={2}>
                        <Typography level={isMobile?"h6":"h4"} color="black">Eligible Affiliates For Media Services</Typography>
                    </Grid>
                    <Box sx={{ width: '100%',}}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                                    <TabList onChange={handleChange} aria-label="secondary tabs example" textColor="inherit"
                                        indicatorColor="primary"
                                        variant="scrollable"
                                        scrollButtons
                                        allowScrollButtonsMobile
                                        sx={{
                                            '& .MuiTabs-indicator': {
                                            backgroundColor: '#6CC641',
                                            height: '3px',
                                            },
                                        }}>
                                        {(user.roles_id === 1 || user.roles_id === 2 || user.roles_id === 3 || user.roles_id === 15) && (
                                            <>
                                                <Tab
                                                    component={Link}
                                                    to="/admin-media-services/eligible"
                                                    value="eligible"
                                                    label="Eligible Affiliates"
                                                    sx={{
                                                        textTransform: "capitalize",
                                                        fontWeight: "bold",
                                                        color: value === "eligible" ? "#6CC641" : "#000000",
                                                        fontSize: "18px"
                                                    }}
                                                />
                                                <Tab
                                                    component={Link}
                                                    to="/admin-media-services/enabled"
                                                    value="enabled"
                                                    label="Enabled Affiliates"
                                                    sx={{
                                                        textTransform: "capitalize",
                                                        fontWeight: "bold",
                                                        color: value === "enabled" ? "#6CC641" : "#000000",
                                                        fontSize: "18px"
                                                    }}
                                                />
                                                <Tab
                                                    component={Link}
                                                    to="/admin-media-services/requested"
                                                    value="requested"
                                                    label="Requsted Services"
                                                    sx={{
                                                        textTransform: "capitalize",
                                                        fontWeight: "bold",
                                                        color: value === "requested" ? "#6CC641" : "#000000",
                                                        fontSize: "18px"
                                                    }}
                                                />
                                                {user.roles_id !== 15 && (
                                                    <Tab
                                                        component={Link}
                                                        to="/admin-media-services/blocked"
                                                        value="blocked"
                                                        label="Blocked Affiliates"
                                                        sx={{
                                                            textTransform: "capitalize",
                                                            fontWeight: "bold",
                                                            color: value === "blocked" ? "#6CC641" : "#000000",
                                                            fontSize: "18px"
                                                        }}
                                                    />
                                                )}
                                            </>
                                        )}
                                    
                                    </TabList>
                            </Box>
                            {(user.roles_id === 1 || user.roles_id === 2 || user.roles_id === 3 || user.roles_id === 15) && (
                            <>
                            <TabPanel value="eligible"><EligibleAffiliateList handleFreezStart={handleFreezStart} handleFreezStop={handleFreezStop}/></TabPanel>
                            <TabPanel value="enabled"><MediaServiceEnabledAffiliateList handleFreezStart={handleFreezStart} handleFreezStop={handleFreezStop}/></TabPanel>
                            <TabPanel value="requested"><MediaServiceReqestedAffiliateList handleFreezStart={handleFreezStart} handleFreezStop={handleFreezStop}/></TabPanel>
                            <TabPanel value="blocked"><BlockAffiliateList handleFreezStart={handleFreezStart} handleFreezStop={handleFreezStop}/></TabPanel>
                            </>
                            )}
                        </TabContext>
                    </Box>
             
            </>
     
    return (
        <div>
            <DefaultLayout content={ContentLayout} />
            {/* loader code start */}
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
            {/* loader code end */}
        </div>
    );
}

export default AdminMediaServices;